import React, { useEffect, useState } from 'react';

const AdminDashboard = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('token');
    fetch('/api/admin/users', {
      headers: { 'Authorization': `Bearer ${token}` }
    })
      .then(r => r.json())
      .then(data => {
        if (data.error) setError(data.error);
        else setUsers(data);
        setLoading(false);
      })
      .catch(() => { setError('Failed to load'); setLoading(false); });
  }, []);

  if (loading) return <div style={styles.center}>Loading...</div>;
  if (error) return <div style={styles.center}>Error: {error}</div>;

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Admin Dashboard</h2>
      <p style={styles.subtitle}>Total Users: {users.length}</p>
      <table style={styles.table}>
        <thead>
          <tr style={styles.headerRow}>
            <th style={styles.th}>Name</th>
            <th style={styles.th}>Email</th>
            <th style={styles.th}>Joined</th>
            <th style={styles.th}>Compiles</th>
            <th style={styles.th}>Plan</th>
          </tr>
        </thead>
        <tbody>
          {users.map(u => (
            <tr key={u.id} style={styles.row}>
              <td style={styles.td}>{u.name}</td>
              <td style={styles.td}>{u.email}</td>
              <td style={styles.td}>{new Date(u.createdAt).toLocaleDateString()}</td>
              <td style={styles.td}>{u.compileCount}</td>
              <td style={styles.td}>
                <span style={u.isPro ? styles.pro : styles.free}>
                  {u.isPro ? 'Pro' : 'Free'}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const styles = {
  container: { padding: '30px', fontFamily: 'Arial, sans-serif', maxWidth: '900px', margin: '0 auto' },
  title: { fontSize: '24px', fontWeight: 'bold', marginBottom: '5px' },
  subtitle: { color: '#666', marginBottom: '20px' },
  table: { width: '100%', borderCollapse: 'collapse' },
  headerRow: { backgroundColor: '#f1f5f9' },
  th: { padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0', fontWeight: 'bold' },
  td: { padding: '12px', borderBottom: '1px solid #e2e8f0' },
  row: { backgroundColor: '#fff' },
  pro: { backgroundColor: '#dcfce7', color: '#166534', padding: '3px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: 'bold' },
  free: { backgroundColor: '#f1f5f9', color: '#475569', padding: '3px 10px', borderRadius: '12px', fontSize: '12px' },
  center: { textAlign: 'center', marginTop: '50px', fontSize: '18px' }
};

export default AdminDashboard;
